__turbopack_context__.v({
  "button": "listing-action-buttons-module-scss-module__x76PAa__button",
  "container": "listing-action-buttons-module-scss-module__x76PAa__container",
  "likeButton": "listing-action-buttons-module-scss-module__x76PAa__likeButton",
  "shareButton": "listing-action-buttons-module-scss-module__x76PAa__shareButton",
  "shareWrapper": "listing-action-buttons-module-scss-module__x76PAa__shareWrapper",
});
